import { render, staticRenderFns } from "./HighlightedCategories.vue?vue&type=template&id=29a9bd45"
import script from "./HighlightedCategories.vue?vue&type=script&lang=js"
export * from "./HighlightedCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports